export const environment = {
  production: false,
  apiUrl: 'https://development-api.thehuro.com',
  environmentName: 'development',
  portal: 'business',
  contractorPortalUrl: 'https://dev-contractor.thehuro.com',
  storageUrl: 'https://thehuro-files-development.s3.us-east-2.amazonaws.com',
  facilityPortalUrl: 'https://dev-facility.thehuro.com',
  corporatePortalUrl: 'https://dev-corporate.thehuro.com'
};
